import React from "react";

import { ProductVisibilityTypes } from "@utils/enums";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import "./noDelivery.scss";

type Props = {
    visibilityType: ProductVisibilityTypes;
};

const NoDelivery = ({ visibilityType }: Props) => {
    const { t } = useGranite();
    return (
        <div className="d-flex mt-2">
            <button
                className="no-delivery btn btn-large btn-outline-primary w-100 disabled"
                disabled
            >
                {t(`ecommerce.text.${visibilityType}`)}
            </button>
        </div>
    );
};

export default NoDelivery;
